document.addEventListener("DOMContentLoaded", function () {
  const sideMenuNav = document.getElementById("js-side-menu-nav");
  const sideMenuNavList = sideMenuNav ? sideMenuNav.querySelector("ul") : null;
  const sideMenuToggle = document.getElementById("js-side-menu-toggle");

  if (!sideMenuNavList || !sideMenuToggle) {
    return;
  }

  const sideMenuNavHeight = sideMenuNav.offsetHeight;
  const sideMenuNavListHeight = sideMenuNavList.offsetHeight;

  if (sideMenuNavHeight >= sideMenuNavListHeight) {
    sideMenuNav.style.paddingBottom = "0";
    sideMenuToggle.style.display = "none";
    return;
  }

  sideMenuToggle.addEventListener("click", function () {
    this.classList.toggle("is-open");
    sideMenuNav.classList.toggle("is-open");
  });
});